import {Exclude, Type} from 'class-transformer';
import {BaseIdModel, BaseIdQuery} from 'common-shared';
import {PropertyMappingModel} from "./property-mapping.model";

export class PropertyLineModel extends BaseIdModel {
  PropertyId: string;
  UnitId?: string;
  NumericValue?: number;
  @Type(() => Date)
  DateTimeValue?: Date;
  ValueClv?: string;
  Value: string;
  PropertyHeaderId: string;
  SourceCode: string;
  SourceType: string;
  SourceId: string;
  @Type(() => PropertyMappingModel)
  @Exclude({ toPlainOnly: true })
  $Mapping?: PropertyMappingModel;
  LanguageId?: string;
  @Type(() => PropertyLineModel)
  @Exclude({ toPlainOnly: true })
  $inheritedFrom: PropertyLineModel;
}

export class PropertyLineQuery extends BaseIdQuery {
  PropertyId: string;
  UnitId?: string;
  NumericValue?: number;
  ValueClv?: string;
  Value: string;
  LanguageId?: string;
}
